export class WindowHelper {
    public static isMobile(): boolean {
        return window.matchMedia('only screen and (max-width: 576px)').matches;
    }
}
